// src/srcSet of a WP image Gatsby resized for the place it is shown in
// (localFile.childImageSharp.gatsbyImageData in the page query). Null for
// files sharp does not process, such as SVG; callers then use the WP sizes.
const sharpImage = image =>
  image?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback ?? null

export default sharpImage
